module.exports = __webpack_public_path__ + "img/4-1.381a1675.png";